import { Journey } from '../features/journeys/types/journey-api-response'
import { TriggerType } from '@pushly/models/lib/enums/journeys'

export function extractJourneyTriggerType(journey: Journey | undefined | null): TriggerType | undefined {
    return journey?.configuration?.computed_trigger_type
}
